export enum ConversionType {
    Email = 'Email',
    Phone = 'Phone',
    StartWebForm = 'StartWebForm',
    FinishWebForm = 'FinishWebForm',
    Subscribe = 'Subscribe',
    Review = 'Review',
    Chat = 'Chat',
    ContactUs = 'ContactUs',
    Share = 'Share',
}

export interface Conversion {
    conversionType: ConversionType;
    target: string;
    clickedAt: Date;
    pageUrl?: string;
    ruleId?: string;
    type: 'Conversion';
}

export interface ConversionRule {
    id: string;
    type: ConversionType;
    querySelector: string;
    path?: string;
}
